angular.module("uib/template/carousel/slide.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("uib/template/carousel/slide.html",
    "<div class=\"text-center\" ng-transclude></div>\n" +
    "");
}]);



//////////////////
// WEBPACK FOOTER
// ./~/angular-ui-bootstrap/template/carousel/slide.html.js
// module id = 472
// module chunks = 1